export default __webpack_public_path__ + "static/media/loader.ed1ba4ce.svg";